import { useMutation } from "@tanstack/react-query";
import { useParams } from "react-router";
import { useIntl } from "react-intl";
import type { Genders } from "~enums/genders";
import type { PersonStatuses } from "~enums/personStatuses";
import type { PersonResponse } from "~types/person";
import { useApi } from "./useApi";
import { useNotification } from "~hooks/useNotification";

type CreatePerson = {
  nameFullLocal: string;
  nameFullLatin?: string | null;
  nameAbbreviated?: string | null;
  dob?: string | null;
  status: PersonStatuses;
  nationality?: string;
  gender: Genders;
  additionalDetails?: null | {
    representation?: string | null;
  };
};

export const useCreatePerson = () => {
  const { sport, organizationId } = useParams();
  const { formatMessage } = useIntl();
  const notification = useNotification();
  const request = useApi();

  return useMutation<PersonResponse, Error, CreatePerson>({
    mutationFn: (body: CreatePerson) => request<PersonResponse>(`${sport}/o/${organizationId}/persons`, { method: "POST", body }),
    onSuccess: (response: PersonResponse) => {
      if (response?.data?.length > 0) {
        notification.success({
          message: formatMessage({ id: "person.add.success" }),
          placement: "bottomRight",
        });
      }
    }
  });
};
